import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Template, TemplateService } from '../../services/template.service';

@Component({
  selector: 'app-template-selection',
  templateUrl: './template-selection.component.html',
  styleUrls: ['./template-selection.component.scss']
})
export class TemplateSelectionComponent {
  templates: Template[] = [];
  createdTemplate: Template | null = null;

  constructor(
    private templateService: TemplateService,
    private router: Router
  ) { }


  getTemplates(): void {
    this.templateService.getTemplates().subscribe({
      next: (data) => { this.templates = data || []; }
    });
  }

  onTemplateCreated(template: Template) {
    this.createdTemplate = template;
    this.templates.push(template);
  }

  selectTemplate(templateId: string): void {
    this.router.navigate(['/chat'], { queryParams: { templateId } });
  }

  continueToChat(templateId: string): void {
    this.router.navigate(['/chat'], { queryParams: { templateId } });
  }

}